export interface IAntecipaSlackMessage {
  usuario: string | null | undefined;
  CLI: string;
  data: Date;
  horario: Date;
  acao: string;
}

export enum EAcoesAntecipa {
  antecipaMenu = "Antecipa no Menu",
  consultarRecebiveis = "Consultar Recebíveis",
  enviarDocumentos = "Enviar Documentos",
  simular = "Simular",
  prosseguir = "Prosseguir",
  assinarContrato = "Assinar Contrato",
  solicitouAcesso = "Solicitou acesso"
}

export interface IAntecipaSlackHandler {
  enviar(location: EAcoesAntecipa): Promise<void>;
}

export const AntecipaSlackDi = Symbol("AntecipaSlackDi");
